document.addEventListener('DOMContentLoaded', function () {
    function kapaiShippingDomRemove() {
        const checkBox = document.querySelector('.watt-cart__below-subtotal-kapai');
        if(checkBox) {
            const allLine = document.querySelectorAll('.watt-cart__item');
            if(allLine && allLine.length > 0) {
                let showCheckboxFlag = false
                const keysData = checkBox.getAttribute('data-keys')
                if(!keysData) return
                const keys = keysData.split(';')
                for (const item of allLine) {
                    const lineKey = item.getAttribute('data-key')
                    if(!lineKey) continue
                    if (keys.includes(lineKey)) {
                        showCheckboxFlag = true
                        break
                    }
                }
                if(!showCheckboxFlag) {
                    checkBox.remove()
                }
            }
        }
    }

    document.addEventListener('watt:cart:remove:row', function () {
        kapaiShippingDomRemove()
    })
})

document.addEventListener('watt:prod:var:changed', function (data) {
  try {
    const afterpay = document.querySelector('afterpay-placement');
    if (!afterpay) return;

    if (!data || !data.detail) return;
    const selectedVariant = data.detail.selectedVariant || null;
    const root = data.detail.root || null;

    if (!selectedVariant || !root) return;

    const price = selectedVariant.price / 100;
    afterpay.setAttribute('data-amount', price);
  } catch (err) {
    console.error('watt:prod:var:changed handler error:', err);
  }
});